import { FC, useEffect, useRef, useState } from "react";
import { fetchAsync, postAsync, postWithoutSign } from "../services/ApiHandler";
import React from "react";
import { PromptHint } from "../model/PromptHint";
import { GenerationRequest } from "../model/GenerationRequest";

import { getAccountId, isLoggedIn, saveToken } from "../services/CookieHandler";
import toast, { Toaster, useToaster } from "react-hot-toast";
import { CardRegistrationDialog, CardRegistrationDialogProps } from "../parts/CardRegisterDialog";
import { StripeCard } from "../model/StripeCard";
import { SetupIntentResponse } from "../model/SetupIntentResponse";
import { SubscriptionRecommendDialog } from "../parts/SubscriptionRecommendDialog";
import { FlatPromptHint } from "../model/FlatPromptHint";
import { ModelTaste } from "../model/ModelTaste";
import { LoginDialog } from "../parts/LoginDialog";
import { UNSAFE_DataRouterStateContext, useLocation, useNavigate } from "react-router-dom";
import { Inspiration } from "../model/Inspiration";
import { AspectRatio } from "../model/AspectRatio";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Button, Center, Collapse, Group, Loader, Modal, NumberInput, Radio, RadioGroup, Slider, Tooltip } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useHeaderStore } from "../parts/CommonHeader";
import { RemainCountResponse } from "../model/RemainCountResponse";
import { SubscriptionDialog } from "../parts/SubscriptionDialog";
import { SubscriptionDialogProps } from "../parts/SubscriptionDialog";
import { getNextPlanId } from "../services/SubscriptionService";
import { convertToObject } from "typescript";
import { InspirationDialog } from "../parts/InspirationDialog";
import { Helmet } from "react-helmet";
import { getModalOffset } from "../services/ScreenUtil";
import ImageUploader from "../parts/ImageUploader";
import { SkyFlagDialog } from "../parts/SkyFlagDialog";
import { SkyFlagRewardDialog } from "../parts/SkyFlagRewardDialog";
import { SkyDialogResponse } from "../model/SkyDialogResponse";
import { getSkyFlagUrl } from "../services/SkyFlagUtil";
class FlatPromptResponse {
  largeCategories: string[] = [];
  middleCategories: FlatPromptHint[] = [];
  list: FlatPromptHint[] = [];
}

type PrefillPromptState = {
  prefillPrompt?: string;
  prefillNegativePrompt?: string;
  prefillTasteName?: string;
};

export const ImageGenerationPage: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const search = location.search;
  const query = new URLSearchParams(search);
  const inspirationNumber = query.get('inspiration-number');
  
  const [ratioList, setRatioList] = useState<AspectRatio[]>([]);
  const [selectedLargeCategory, setSelectedLargeCategory] = useState("");
  const [selectedHint, setSelectedHint] = useState<FlatPromptHint[]>([]);
  const [largeCategories, setLargeCategories] = useState<string[]>([]);
  const [negativelargeCategories, setNegativeLargeCategories] = useState<string[]>([]);
  const [inspirationList, setInspirationList] = useState<Inspiration[]>([]);

  const [middleCategories, setMiddleCategories] = useState<FlatPromptHint[]>([]);
  const [hintList, setHintList] = useState<FlatPromptHint[]>([]);
  const [negativeHintList, setNegativeHintList] = useState<FlatPromptHint[]>([]);
  
  const [mainTasteList, setMainTasteList] = useState<ModelTaste[]>([]);
  const [selectedModel, setSelectedModel] = useState<ModelTaste[]>([]);
  const [currentPrompt, setCurrentPrompt] = useState('');
  const [currentNegativePrompt, setCurrentNegativePrompt] = useState('');
  
  const [requestList, setRequestList] = useState<GenerationRequest[]>([]);
  const [processing, setProcessing] = useState(false);
  const [aspectRatio, setAspectRatio] = useState('1:1');
  const [fileFomat, setFileFomat] = useState('jpeg');
  const [bulkCount, setBulkCount] = useState(1);
  const [additionalPrompt, setAdditionalPrompt] = useState('');
  const [additionalNegativePrompt, setAdditionalNegativePrompt] = useState('');
  const [seed, setSeed] = useState('');
  const [stepCount, setStepCount] = useState(20);
  const [scale, setScale] = useState(7.5);
  const [strength, setStrength] = useState(0.6);
  // const [loginFlag, setLoginFlag] = useState(isLoggedIn());
  const [keyword, setKeyword] = useState('');
  const [cardProps, setCardProps] = useState<CardRegistrationDialogProps | undefined>(undefined);
  const selectedItems = useRef<PromptHint[]>([]);

  const [searchText, setSeachText] = useState('');
  const [promptSearchResult, setPromptSearchResult] = useState<FlatPromptHint[]>([]);
  
  const [negativeSearchText, setNegativeSearchText] = useState('');
  const [negativePromptSearchResult, setNegativePromptSearchResult] = useState<FlatPromptHint[]>([]);

  const [loginDialogOpened, { open: openLoginDialog, close: closeLoginDialog }] = useDisclosure(false);
  const [generationRequest, setGenerationRequest] = useState<GenerationRequest| undefined>(undefined);

  const opened = true;
  const openedPrompt = true;
  const [openedDetail, { toggle: toggleDetail }] = useDisclosure(true);
  const onClickToggleDetail = async () => {
    // 詳細設定を開く直前に最新のプラン/残回数を取得して制約を反映
    try {
      if (isLoggedIn) {
        console.log('[PlanRefresh] 詳細設定 open -> fetchActiveSubscription + fetchRemainCount');
        await useHeaderStore.getState().fetchActiveSubscription();
        await useHeaderStore.getState().fetchRemainCount();
      }
    } catch (e) {
      console.log('[PlanRefresh] 詳細設定 refresh error', e);
    }
    toggleDetail();
  };
  const [openedNegative, { toggle: toggleNegative }] = useDisclosure(false);
  const [mobileNegativeVisible, setMobileNegativeVisible] = useState(false);
  const [mobileSettingsVisible, setLocalMobileSettingsVisible] = useState(false);
  
  const { remainCount, setRemainCount, subscription, card, fetchRemainCount, fetchActiveSubscription, onLogin, isLoggedIn, setIsLoggedIn, screenWidth, setMobileSettingsVisible, setProcessingDialogVisible } = useHeaderStore();
  const [subscriptionDialogProps, setSubscriptionDialogProps] = useState<SubscriptionDialogProps | undefined>(undefined);
  const [subscriptionDialogOpened, { open: openSubscriptionDialog, close: closeSubscriptionDialog }] = useDisclosure(false);
  const [skyFlagDialogOpened, { open: openSkyFlagDialog, close: closeSkyFlagDialog }] = useDisclosure(false);
  const [skyFlagRewardDialogOpened, { open: openSkyFlagRewardDialog, close: closeSkyFlagRewardDialog }] = useDisclosure(false);

  const [processingDialogOpened, { open: openProcessingDialog, close: closeProcessingDialog }] = useDisclosure(false);
  const [processingMultiDialogOpened, { open: openProcessingMultiDialog, close: closeProcessingMultiDialog }] = useDisclosure(false);
  const [promptDialogOpened, setPromptDialogOpened] = useState<boolean>(false);
  const [inspiration, setInspiration] = useState<Inspiration | undefined>(undefined);
  const [inspirationDialogOpened, { open: openInspirationDialog, close: closeInspirationDialog }] = useDisclosure(false);
  const [thisPromptButtonVisible, setThisPromptButtonVisible] = useState(false);
  const [bulkCountOption, setBulkCountOption] = useState([1]);
  const [isPromptTranslating, setIsPromptTranslating] = useState(false);
  const [isNegativePromptTranslating, setIsNegativePromptTranslating] = useState(false);
  const [base64, setBase64] = useState('');
  const [resizeMode, setResizeMode] = useState('ResizeAndFill');
  const [pendingTasteName, setPendingTasteName] = useState<string | undefined>(undefined);

  useEffect(() => {
    const state = location.state as PrefillPromptState | null;
    if (state?.prefillPrompt || state?.prefillNegativePrompt || state?.prefillTasteName) {
      setSelectedHint([]);
      if (typeof state.prefillPrompt === 'string') {
        setAdditionalPrompt(state.prefillPrompt);
      }
      if (typeof state.prefillNegativePrompt === 'string') {
        setAdditionalNegativePrompt(state.prefillNegativePrompt);
      }
      if (typeof state.prefillTasteName === 'string') {
        setPendingTasteName(state.prefillTasteName);
      }
      navigate(location.pathname + location.search, { replace: true });
    }
  }, [location.state, location.pathname, location.search, navigate]);

  useEffect(() => {
    if (!pendingTasteName || mainTasteList.length === 0) return;
    const taste = mainTasteList.find((t) => t.name === pendingTasteName || t.modelName === pendingTasteName);
    if (taste) {
      setSelectedModel([taste]);
      setPendingTasteName(undefined);
    }
  }, [pendingTasteName, mainTasteList]);

  useEffect(() => {
    const fetchHintList = async () => {
      const response = await fetchAsync<FlatPromptResponse>('FlatPromptHint/GetList');
      setLargeCategories(response.largeCategories.filter((e) => !e.startsWith('ネガティブプロンプト')));
      setMiddleCategories(response.middleCategories);
      setHintList(response.list.filter((e) => e.isNegativePrompt === false));
      setNegativeHintList(response.list.filter((e) => e.isNegativePrompt === true));
      setNegativeLargeCategories(response.largeCategories.filter((e) => e.startsWith('ネガティブプロンプト')));
    };

    //setDefaultPrompt();
    fetchInspirationList();
    fetchHintList();
    init();

    if (isLoggedIn) {
      const intervalId = setInterval(fetchSkyFlag, 10000);
      return () => clearInterval(intervalId);
    }
  }, [isLoggedIn])

  async function fetchSkyFlag(){
    const response = await fetchAsync<SkyDialogResponse>('SkyFlag/GetDialogFlag');
    if(response.data === true){
      fetchRemainCount();
      openSkyFlagRewardDialog();
    }
  }

  async function init(){
    if(isLoggedIn === true){
      fetchGeneratedList();
    }
    await fetchMainTasteList();
    setSamplaPrompt();
    fetchRatioList();
  }

  useEffect(() => {
    if(subscription?.internalProductId.startsWith('lite') || subscription?.internalProductId.startsWith('standard') || subscription?.internalProductId.startsWith('advanced')) {
      setBulkCountOption([1, 2, 4]);
      setBulkCount(2);
    }
  }, [subscription])

  // タブを開く（フォーカス/再表示）たびに現在のプランを再取得
  useEffect(() => {
    const refreshPlan = () => {
      try {
        console.log('[PlanRefresh] focus/pageshow/visibility -> fetchActiveSubscription');
        // 非ログイン時はAPIコールを避ける
        if (!isLoggedIn) return;
        // 常に最新のstoreから取得（関数参照の変化に影響されない）
        useHeaderStore.getState().fetchActiveSubscription();
      } catch (e) {
        console.log('[PlanRefresh] focus/pageshow/visibility fetch error', e);
      }
    };
    const onFocus = () => refreshPlan();
    const onPageShow = () => refreshPlan();
    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') refreshPlan();
    };
    window.addEventListener('focus', onFocus);
    window.addEventListener('pageshow', onPageShow);
    document.addEventListener('visibilitychange', onVisibilityChange);
    // 初回マウント時に一度同期
    if (document.visibilityState === 'visible') refreshPlan();
    return () => {
      window.removeEventListener('focus', onFocus);
      window.removeEventListener('pageshow', onPageShow);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [isLoggedIn]);

  // ルート遷移で画像生成ページが表示されたタイミングでも再取得
  useEffect(() => {
    try {
      if (location.pathname === '/image-generation') {
        console.log('[PlanRefresh] route enter image-generation -> fetchActiveSubscription + fetchRemainCount');
        if (isLoggedIn) {
          useHeaderStore.getState().fetchActiveSubscription();
          useHeaderStore.getState().fetchRemainCount();
        }
      } else {
        console.log('[PlanRefresh] route change (not image-generation):', location.pathname);
      }
    } catch (e) {
      console.log('[PlanRefresh] route enter refresh error', e);
    }
  }, [location.pathname]);

  // 初回マウント時も必ず取得
  useEffect(() => {
    try {
      console.log('[PlanRefresh] mount image-generation -> fetchActiveSubscription + fetchRemainCount');
      if (isLoggedIn) {
        useHeaderStore.getState().fetchActiveSubscription();
        useHeaderStore.getState().fetchRemainCount();
      }
    } catch (e) {
      console.log('[PlanRefresh] mount refresh error', e);
    }
  }, []);

  useEffect(() => {
    if(isLoggedIn === true){
      onLoginEvent();
    }
  },[isLoggedIn]);

  React.useEffect(() => {
    if (isLoggedIn === false) {
      return;
    }

    const id = setInterval(() => {
      var startedCount = requestList.filter((e) => e.status === 'started').length;
      if(startedCount == 0) {
        return;
      }
      fetchGeneratedList();
      fetchRemainCount();
    }, 1000);
    return () => clearInterval(id);
  }, [requestList]);


  async function setSamplaPrompt(){

    if(inspirationNumber === null || inspirationNumber === ''){
      return;
    }

    var param = { inspirationNumber: inspirationNumber };
    const response = await fetchAsync<Inspiration>('Inspiration/GetSingle', param);
    const list = await fetchAsync<ModelTaste[]>('ModelTaste/GetList');

    var taste = list.filter((e) => e.modelName == response.modelTaste)[0];

    var tasteList = [];
    tasteList.push(taste);
    setSelectedModel(tasteList);
    setAdditionalPrompt(response.prompt);
    setAdditionalNegativePrompt(response.negativePrompt);
  }

  const updateMobileSettingsVisible = async (visible: boolean) => {
    if (visible && isLoggedIn) {
      try {
        console.log('[PlanRefresh] モバイル画像設定 open -> fetchActiveSubscription + fetchRemainCount');
        await useHeaderStore.getState().fetchActiveSubscription();
        await useHeaderStore.getState().fetchRemainCount();
      } catch (e) {
        console.log('[PlanRefresh] モバイル画像設定 refresh error', e);
      }
    }
    setLocalMobileSettingsVisible(visible);
    setMobileSettingsVisible(visible);
  };

  const openProcessingDialogWithHeader = () => {
    openProcessingDialog();
    setProcessingDialogVisible(true);
  };

  const closeProcessingDialogWithHeader = () => {
    closeProcessingDialog();
    setProcessingDialogVisible(false);
  };

  async function fetchInspirationList() {
    var params = {
      page: 0,
      count: 100
    };
    const response = await fetchAsync<Inspiration[]>('Inspiration/GetList', params);
    response.sort(() => Math.random() - 0.5);
    setInspirationList(response);
  };

  async function fetchMainTasteList (){
    const list = await fetchAsync<ModelTaste[]>('ModelTaste/GetList');
    setMainTasteList(list);
  };

  async function fetchGeneratedList (){
    var param = {
      count: 20, 
      page: 0,
      asc: false,
      containsNsfw: true,
      containsError: true,
    };
    const list = await fetchAsync<GenerationRequest[]>('Generation/GetGeneratedImages', param);
    setRequestList(list);
    if(list.length >= 1) {
      setGenerationRequest(list[0]);
    }
  };

  async function fetchRatioList (){
    const list = await fetchAsync<AspectRatio[]>('AspectRatio/GetList');
    setRatioList(list);
  };

  async function buildImage() {
    if(selectedModel.length === 0) {
      toast.error("モデルのテイストを選んでください");
      return;
    }

    if(selectedHint.length === 0 && currentPrompt === '' && additionalPrompt === '') {
      toast.error("プロンプトを選んでください");
      return;
    }

    var startedCount = requestList.filter((e) => e.status === 'started').length;
    if(startedCount && startedCount >= 1) {
      toast.error("現在画像生成中です。");
      return;
    }
    
    if(processing) {
      return;
    }

    if(isLoggedIn === false) {
      openLoginDialog();
      return;
    }

    setGenerationRequest(undefined);
    setProcessing(true);
    setThisPromptButtonVisible(false);
    
    var uids = selectedHint.map(e => e.uid);
    selectedItems.current = [];
    
    var param = {
      prompt: currentPrompt,
      negativePrompt: currentNegativePrompt,
      aspectRatio: aspectRatio,
      bulkCount: bulkCount,
      seed: seed,
      outputFormat: fileFomat,
      selectedHintUidList: uids,
      additionalPrompt: additionalPrompt,
      additionalNegativePrompt: additionalNegativePrompt,
      modelTasteUid: selectedModel[0].uid,
      guidanceScale: scale.toString(),
      inferenceSteps: stepCount.toString(),
      isImg2img: base64 === '' ? false : true,
      originalImageBase64: base64,
      strength: strength.toString(),
      resizeMode: resizeMode
    };

    
    const response = await postAsync<string>("Generation/Generate", param);
    

    if (response.code === -2) {
      if(subscription?.internalProductId.startsWith('standard')) {
        toast.error("プランの生成回数を使い切りました。");
      } else{
        toast.error("プランの生成回数を使い切りました。");
        setSubscriptionDialogProps({
          planId: getNextPlanId(subscription),
          isTrial: true
        } as SubscriptionDialogProps);
        openSubscriptionDialog(); 
      }
    }

    if(response.code === 1) {
      if(bulkCount == 1) {
        await fetchGeneratedList();
        openProcessingDialogWithHeader();
      } else {
        openProcessingMultiDialog();
      }
    }
    
    fetchGeneratedList();
    setProcessing(false);
    
    fetchRemainCount();
  }

  const fileFormatList = ['jpeg', 'png'];
  const resizeModeList = [
    {
      label: 'Resize and fill（推奨）',
      value: 'ResizeAndFill'
    },
    {
      label: 'Just resize',
      value: 'JustResize'
    },
    {
      label: 'Just resize latent upscaler',
      value: 'LatentUpscale'
    },
    {
      label: 'Crop and resize',
      value: 'CropAndResize'
    }
  ];

  function onClickThisPrompt(request: GenerationRequest){
    setSelectedHint([]);
    setAdditionalPrompt(request.prompt + ' ' + request.additionalPrompt);
    setAdditionalNegativePrompt(request.negativePrompt + ' ' + request.additionalNegativePrompt);
    closeProcessingDialogWithHeader();
  }

  async function onLoginEvent() {
     setIsLoggedIn(true);
     closeLoginDialog();
     fetchGeneratedList();
     fetchActiveSubscription();
     fetchRemainCount();
  }

  function setClipboard(text: string | undefined){
    navigator.clipboard.writeText(text ?? '');
    toast.success("クリップボードにコピーしました");
  }

  function setWordsClipboard(text1: string | undefined, text2: string | undefined){
    navigator.clipboard.writeText(`${text1 ?? ''} ${text2 ?? ''}`);
    toast.success("クリップボードにコピーしました");
  }


  function buildDetailDialog(){
    if(selectedLargeCategory === '') {
      return <></>;
    }

    var selectedMiddleCategories = middleCategories.filter((e) => e.largeCategory === selectedLargeCategory);
    const selectedHintList = selectedLargeCategory === 'ネガティブプロンプト' ? negativeHintList : hintList;

    return <>
      <div id="login-dialog" className="dialog-overlay">
        <div className='dialog text-start max-h-[80vh] overflow-scroll' style={{ width: "unset", paddingTop: '0px' }}>
          <div className="pb-10 pt-4 bg-white" style={{ position: 'sticky', top: '0px'}}>
            <div className="mb-2 text-lg flex justify-between absolute w-full">
              <span>{ selectedLargeCategory }</span>
              <img onClick={(e) => setSelectedLargeCategory('')} src="/images/icon-close.svg" className="clickable w-[32px]"></img>
            </div>
          </div>
          { selectedMiddleCategories.map((middle) => (
            <div className="mb-4">
              <div className="mb-1">{middle.middleCategory}</div>
              <div>
              { selectedHintList.filter((e) => e.largeCategory === selectedLargeCategory && e.middleCategory === middle.middleCategory).map((small) => (
                buildHintSpan(small, false)
              ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </>;
  }

  function buildProcessingDialog(){
    let request = generationRequest;
    return <>
    <Helmet>
      <title>画像生成 - Drop AI</title>
      <meta name="description" content="お気に入りのモデルとプロンプトを選ぶだけ！高品質なAI画像を生成しよう。" />
      <meta property="og:url" content="https://drop4i.com/image-generation" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="画像生成 - Drop AI | 無料で使えるAI画像生成ツール" />
      <meta property="og:description" content="お気に入りのモデルとプロンプトを選ぶだけ！高品質なAI画像を生成しよう。" />
    </Helmet>
    <Modal zIndex={300} size="auto" opened={processingDialogOpened} onClose={closeProcessingDialogWithHeader}>
      <div className='text-start max-h-[80vh] overflow-scroll w-full sm:w-[1080px]' style={{ paddingTop: '0px' }}>
        <div className="block sm:flex">
          <div className="w-full sm:w-[50%] items-center sm:min-h-[500px] justify-center">
            <div className="min-w-[100%] px-1 my-1">
              { (remainCount === undefined || request?.status === 'started') &&
                <div key={request?.uid} className="text-center min-h-[250px] sm:min-h-[450px] align-middle justify-center flex items-center" style={{ marginTop: "auto"}}>
                  <div className="flex flex-col items-center h-full">
                    <Loader type="dots" />
                  <span className="text-sm mt-2">画像生成中</span>
                  </div>
                </div>
              }
              { ( request !== undefined && request.status === 'complete' ) &&
                <>
                { request!.isNsfw === 1 &&
                  <div key={request.uid} className="w-[100%] min-w-[95px] h-[100%] min-h-[240px] sm:min-h-[480px] p-1bg-black text-white text-center flex items-center justify-center px-6 bg-black text-xs">
                    不適切な画像を生成した可能性がございます
                  </div>
                }
                { request!.isNsfw === 0 &&
                <div key={request.uid}>
                  <img style={{ width: '100%' }} src={`${process.env.REACT_APP_IMAGE_URL}/${request.requestId}`} />
                </div>
                }
                </>
              }
              { ( request !== undefined && request.status === 'error' ) &&
                <div key={request.uid} className="w-[100%] min-w-[95px] h-[100%] min-h-[240px] sm:min-h-[480px] p-1bg-black text-white text-center flex items-center justify-center px-4 bg-black">
                  画像生成エラーが発生しました。時間をおいてリトライしてください。<br />
                  何度トライしてもエラーが解消されない場合、大変お手数ですがコンタクトページよりお問い合わせをくださいませ。<br />
                </div>
              }
            </div>
          </div>
          <div className="w-full sm:w-[50%] ml-0 sm:ml-4 mt-4 sm:mt-0">
            <div className="text-sm font-bold">モデルテイスト</div>
            <div className="text-sm py-1 rounded">
              { request?.tasteName }
            </div>
            <div className="text-sm mr-4 mt-4 font-bold">プロンプト</div>
            <div className="text-sm py-1 px-2 min-h-7 rounded flex justify-between bg-gray-100">
              { `${request?.prompt} ${request?.additionalPrompt}` }
              <img onClick={(e) => setWordsClipboard(request?.prompt, request?.additionalPrompt)} src="/images/icon/icon-copy.svg" className="clickable w-[20px]"></img>
            </div>
            <div className="text-sm mt-4 font-bold">ネガティブプロンプト</div>
            <div className="text-sm py-1 px-2 min-h-7 rounded flex justify-between bg-gray-100">
              <span className="mr-1">{ `${request?.negativePrompt} ${request?.additionalNegativePrompt}` }</span>
              <img onClick={(e) => setWordsClipboard(request?.negativePrompt, request?.additionalNegativePrompt)} src="/images/icon/icon-copy.svg" className="clickable w-[20px]"></img>
            </div>
            <div className="text-sm mt-4 font-bold">画像アスペクト比</div>
            <div className="text-sm py-1 px-2 rounded">
              { `${request?.aspectRatio} (${request?.width}px x ${request?.height}px)` }
            </div>
            <div className="text-sm mt-4 font-bold">ステップ数</div>
            <div className="text-sm py-1 rounded">
              { request?.inferenceSteps }
            </div>
            <div className="text-sm mt-2 font-bold">シード値</div>
            <div className="text-sm py-1 px-2 rounded flex justify-between bg-gray-100">
              <span>{ request?.seed }</span>
              <img onClick={(e) => setClipboard(request?.seed?.toString())} src="/images/icon/icon-copy.svg" className="clickable w-[20px]"></img>
            </div>
            <div className="text-sm mt-2 font-bold">スケール</div>
            <div className="text-sm py-1 rounded">
              { request?.guidanceScale }
            </div>
            { request?.isImg2Img === true &&
            <>
            <div className="text-sm mt-2 font-bold">img2img ノイズ除去の強度</div>
            <div className="text-sm py-1 rounded">
                { request?.strength }
              </div>
            </>
            }
            <div className="mt-6">
              { thisPromptButtonVisible &&
                <button className="w-full gradation-button py-2 px-12 rounded font-bold clickable" onClick={(e) => onClickThisPrompt(request!)}>このプロンプトを利用する</button>
              }
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </>;
  }

  function onSelectGenerationImage(request: GenerationRequest){
    setGenerationRequest(request);
    openProcessingDialogWithHeader();
  }

  function buildMultiProcessingDialog(){
    if(requestList.length == 0) {
      return <></>;
    }

    let screenWidth = window.innerWidth;
    let list = requestList.slice(0, bulkCount).reverse();
    var height = bulkCount == 4 ? 500 : 200;
    var width = bulkCount == 4 ? 600 : 800;

    if(screenWidth <= 640) {
      var height = bulkCount == 4 ? 150 : 100;
      var width = bulkCount == 4 ? 300 : 300;
    }

    var imageWidth = (width / 2);
    var imageHeight = bulkCount == 4 ? 300 : height;
    
    return <>
    <Modal size="auto" opened={processingMultiDialogOpened} onClose={closeProcessingMultiDialog}>
      <div className='max-h-[80vh] overflow-scroll' style={{ width: `${width}px`, paddingTop: '0px' }}>
        <div className="">
          <div className={`block sm:flex items-center min-h-[${height}px] inline-flex flex-wrap justify-around`}>
          { list.map((item) => (
            <div className="px-1 my-1" style={{ width: `${imageWidth}px` }}>
              { item.status === 'started' &&
                <div key={item.uid} className={`text-center align-middle justify-center flex items-center`} style={{ marginTop: "auto", minHeight: `${imageHeight}px` }}>
                  <div className="flex flex-col items-center h-full">
                    <Loader type="dots" />
                    <span className="text-sm mt-2">画像生成中</span>
                  </div>
                </div>
              }
              { item.status === 'complete' &&
                <>
                { item.isNsfw === 1 &&
                  <div key={item.uid} style={{ height: `${imageHeight}px`, width: `${imageWidth}px` }} className="bg-black text-white text-center flex items-center justify-center bg-black text-xs px-4">
                    不適切な画像を生成した可能性がございます
                  </div>
                }
                { item.isNsfw === 0 &&
                <div onClick={(e) => onSelectGenerationImage(item)}  key={item.uid} className="clickable">
                  <img style={{ width: `${imageWidth}px` }} src={`${process.env.REACT_APP_IMAGE_URL}/${item.requestId}`} />
                  </div>
                }
                </>
              }
              { item.status === 'error' &&
                <div key={item.uid} style={{ height: `${imageHeight}px`, width: `${imageWidth}px` }} className="bg-black text-white text-center flex items-center justify-center bg-black">
                  エラーが発生しました
                </div>
              }
            </div>    
          ))}
          </div>
        </div>
      </div>
    </Modal>
  </>;
  }

  function toggleModelTaste(hint: ModelTaste) {
    let newList = [hint];
    setSelectedModel(newList);
  }

  function toggleSelect(hint: FlatPromptHint) {
    let newList = [...selectedHint];
    hint.isFocused = false;
    var hasHint = selectedHint.filter((e) => e.uid == hint.uid).length >= 1;
    if(hasHint) {
      newList = newList.filter((e) => e.uid !== hint.uid);
    } else {
      newList.push(hint);
    }
    setSelectedHint(newList);

    var selectedPrompt = newList.filter((e) => e.prompt !== '').map(e => e.isFocused ? `((${e.prompt}))` : e.prompt).join(",");
    var selectedNegativePrompt = newList.filter((e) => e.negativePrompt !== '').map(e => e.isFocused ? `((${e.negativePrompt}))` : e.negativePrompt).join(",");
    setCurrentPrompt(selectedPrompt);
    setCurrentNegativePrompt(selectedNegativePrompt);
  }

  function buildHintSpan(item: FlatPromptHint, isNegative: boolean) {
    const isSelected = selectedHint.filter((e) => e.uid === item.uid).length >= 1;
    var color = "#03034F";
    var borderColor = isSelected ? "#0909FF" : "#CED4DA";
    var bgColor = isSelected ? "#CFCFFF" : "#fff";

    if(isNegative && isSelected) {
      borderColor = "#F416BF";
      bgColor = "#FFD0F4";
    }

    var svgPath = "";
    if(isNegative) {
      svgPath = isSelected ? "/images/icon/icon-minus-red.svg" : "/images/icon/icon-minus-grey.svg";
    } else {
      svgPath = isSelected ? "/images/icon/icon-plus-blue.svg" : "/images/icon/icon-plus-grey.svg";
    }

    return <span onClick={(e) => toggleSelect(item)} className="clickable border rounded-xl mr-2 px-2 py-1 whitespace-nowrap" style={{ lineHeight: '36px', borderColor: borderColor, color: color, backgroundColor: bgColor }}>
      <span className="mr-1 clickable items-center inline-flex" style={{ color: borderColor}}>
        <img src={svgPath} className="w-[12px] h-[12px] inline"></img>
      </span>
      {item.name}
      </span>;
  }

  function buildSelectedSpan(item: FlatPromptHint, isNegative: boolean) {
    var borderColor = item.isFocused ? "#0909FF" : "#0909FF";
    var bgColor = item.isFocused ? "#CFCFFF" : "#EAEAFF";
    
    if(isNegative) {
      borderColor = "#F416BF";
      bgColor = "#FFD0F4";
      if(item.isFocused) {
        bgColor = "#FFD0F4";
      }
    }

    var svgPath = isNegative ? "/images/icon/icon-minus-red.svg" : "/images/icon/icon-plus-blue.svg";
    var upArrowPath =  isNegative ? "/images/icon/up-arrow-red.svg" : "/images/icon/up-arrow-blue.svg";

    return <>
    <span className="mb-2 border rounded-xl mr-1 pl-2 pr-2 py-0.5 whitespace-nowrap inline-flex w-auto items-center text-primary" style={{ borderColor: borderColor, backgroundColor: bgColor }}>
      <span className="mr-1 text-[#0909FF] clickable" onClick={(e) => toggleFocus(item)}>
        <img src={svgPath} className="w-[12px] h-[12px] inline"></img>
      </span>
      { item.isFocused  &&
      <img onClick={(e) => toggleFocus(item)} src={upArrowPath} className="h-[14px] clickable mr-1"></img>
      }
      <span className="text-sm" onClick={(e) => toggleFocus(item)}>{item.name}</span>
      <img onClick={(e) => toggleSelect(item)} src="/images/icon-close.svg" className="h-[14px] clickable ml-1 sm:pr-0 pr-2"></img>
    </span>
    </>;
  }

  function toggleFocus(item: FlatPromptHint) {
    let newList = [...selectedHint];
    var index = selectedHint.findIndex((e) => e.uid == item.uid);
    item.isFocused = !item.isFocused;
    
    newList[index] = item;
    setSelectedHint(newList);

    var selectedPrompt = newList.filter((e) => e.prompt !== '').map(e => e.isFocused ? `((${e.prompt}))` : e.prompt).join(",");
    setCurrentPrompt(selectedPrompt);

    var selectedNegativePrompt = newList.filter((e) => e.negativePrompt !== '').map(e => e.isFocused ? `((${e.negativePrompt}))` : e.negativePrompt).join(",");
    setCurrentNegativePrompt(selectedNegativePrompt);
  }

  function buildTasteImage(item: ModelTaste) {
    const isSelected = selectedModel.filter((e) => e.uid === item.uid).length >= 1;
    var borderStyle = isSelected ? "3px solid #0909FF" : "3px solid white";
    const opacity = isSelected ? 0.8 : 1;
    return <>
      <div key={`taste-${item.uid}`} onClick={(e) => toggleModelTaste(item)} className="relative mr-2 clickable rounded-md" style={{ border: borderStyle, opacity: opacity }}>
        <div className="w-full text-center absolute flex items-center h-[100%]">
          <span className="text-white w-[100%]" style={{ fontWeight: "900", fontSize: "15px", WebkitTextStrokeWidth: "0.2px", WebkitTextStrokeColor: "#000000", whiteSpace: "break-spaces" }}>{item.name}</span>
        </div>
        <img src={`/images/taste/${item.sampleImageFile}`} className="min-w-[120px] min-h-[120px] w-[120px] h-[120px] rounded" style={{ objectFit: "cover" }}></img>
      </div>
    </>;
  }

  async function onSelectInspiration(inspiration: Inspiration){
    setInspiration(inspiration);
    openInspirationDialog();
  }

  function sleep(ms:number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function buildSearchOption(hint: FlatPromptHint){
    return <>
      <div onClick={(e) => onSelectSearchOption(hint)} className="py-1 px-1 min-w-[200px] text-gray-600 clickable">
        {hint.name}
      </div>
    </>;
  }

  function clearSettings(){
    setSelectedModel([]);
    setSelectedHint([]);
    setCurrentPrompt('');
    setCurrentNegativePrompt('');
    setAdditionalNegativePrompt('');
    setAdditionalPrompt('');
  }

  function buildAspectRatioOption(ratio: AspectRatio){
    var width = 0;
    var height = 0;
    if(ratio.ratio === '1:1'){ width = 55; height = 55; }
    if(ratio.ratio === '2:1'){ width = 55; height = 27.5; }
    if(ratio.ratio === '3:2'){ width = 55; height = 36.67; }
    if(ratio.ratio === '2:3'){ width = 36.67; height = 55; }
    if(ratio.ratio === '9:16'){ width = 30.9375; height = 55; }
    if(ratio.ratio === '16:9'){ width = 55; height = 30.9375; }

    var isSelected = aspectRatio === ratio.ratio;    
    return <div className="text-sm py-1 text-center align-middle clickable justify-between">
        <div className="w-min mx-auto">
          <Radio color="#0909FF" key={`format-${ratio.ratio}`} value={ratio.ratio}></Radio>
        </div>
        <span onClick={(e) => setAspectRatio(ratio.ratio)} className="min-h-[60px] block mt-1">
          <label htmlFor={ratio.ratio} className="text-xs border rounded-md inline-flex items-center justify-center" style={{ width: `${width}px`, height: `${height}px`, borderColor: isSelected ? '#0909FF' : '', color: isSelected ? '#0909FF' : '', backgroundColor: isSelected ? '#EAEAFF' : '' }}>{ratio.ratio}</label>
        </span>
      </div>;

  }

  function onSelectSearchOption(hint: FlatPromptHint){
    toggleSelect(hint);
    setPromptSearchResult([]);
    setSeachText('');
    setNegativePromptSearchResult([]);
    setNegativeSearchText('');
  }

  function onChangeSearchText(text: string) {
    setSeachText(text);
    if (text == '') {
      setPromptSearchResult([]);
      return;
    }

    var list = hintList.filter((e) => e.name.includes(text)).slice(0, 10);
    setPromptSearchResult(list);
  }

  function onChangeNegativeSearchText(text: string) {
    setNegativeSearchText(text);
    if (text == '') {
      setNegativePromptSearchResult([]);
      return;
    }

    var list = negativeHintList.filter((e) => e.name.includes(text)).slice(0, 10);
    setNegativePromptSearchResult(list);
  }

  function buildInspirationDialog(){
    return <>
    <Modal size="auto" opened={inspirationDialogOpened} onClose={() => closeInspirationDialog()}>
      <InspirationDialog inspiration={inspiration} mainTasteList={mainTasteList} />
    </Modal>
    </>;
  }

  function onClickGeneratedImage(item: GenerationRequest){
    setThisPromptButtonVisible(true);
    setGenerationRequest(item);
    openProcessingDialogWithHeader();
  }

  function clearPromptHint(){
    setSelectedHint(selectedHint.filter((e) => e.isNegativePrompt === true));
    setAdditionalPrompt('');
  }

  function clearNegativePromptHint(){
    setSelectedHint(selectedHint.filter((e) => e.isNegativePrompt === false));
    setAdditionalNegativePrompt('');
  }

  function onCloseSubscriptionDialog(){
    closeSubscriptionDialog();
    setProcessing(false);
  }

  function onCloseSkyFlagDialog(){
    closeSkyFlagDialog();
    setProcessing(false);
  }

  async function translatePrompt(isPrompt: boolean) {
    if(isPrompt) {
      setIsPromptTranslating(true);
    } else {
      setIsNegativePromptTranslating(true);
    }

    var prompt = isPrompt ? additionalPrompt : additionalNegativePrompt;
    var param = { OriginalText: prompt, IsNegativePrompt: isPrompt };
    var response = await postAsync<string>('Translate/Translate', param);
    if(response.code === 1) {
      return response.data!;
    }
    
    if(isPrompt) {
      setAdditionalPrompt(response.data!);
    } else {
      setAdditionalNegativePrompt(response.data!);
    }
    if(isPrompt) {
      setIsPromptTranslating(false);
    } else {
      setIsNegativePromptTranslating(false);
    }
  }

  function onSetBase64(base64: string) {
    setBase64(base64);
  }

  return <>
    { buildDetailDialog() }
    { buildMultiProcessingDialog()}
    { buildProcessingDialog() }
    { inspiration && buildInspirationDialog() }
    
    <Modal size="auto" opened={subscriptionDialogOpened} onClose={() => { closeSubscriptionDialog(); openSkyFlagDialog(); }} yOffset={getModalOffset(screenWidth)} >
      <SubscriptionDialog
        upgradeTextVisible={true}
        onPurchase={() => closeSubscriptionDialog()}
        onCancel={() => { closeSubscriptionDialog(); openSkyFlagDialog(); }}
        planId={subscriptionDialogProps?.planId} />
    </Modal>

    <Modal size="auto" opened={skyFlagRewardDialogOpened} onClose={closeSkyFlagRewardDialog} yOffset={getModalOffset(screenWidth)} >
      <SkyFlagRewardDialog />
    </Modal>

    <Modal size="auto" opened={skyFlagDialogOpened} onClose={onCloseSkyFlagDialog} yOffset={getModalOffset(screenWidth)} >
      <SkyFlagDialog
        onClick={() => closeSkyFlagDialog()}
        onCancel={() => closeSkyFlagDialog()} />
    </Modal>
  
    { cardProps !== undefined &&
    <CardRegistrationDialog clientSecret={cardProps?.clientSecret!} onClose={() => setCardProps(undefined)} />
    }
    <Toaster />
    <Modal size="auto" opened={loginDialogOpened} onClose={closeLoginDialog}>
      <LoginDialog onCancel={() => closeLoginDialog()}  onLogin={() => onLoginEvent()} isLogin={true} />
    </Modal>
    <div className="block sm:flex sm:pt-4 sm:ml-2" style={{backgroundColor: '#eaeaea80'}}>

      <div id="center-cell" className="sm:ml-4 w-full sm:rounded-md mb-0 sm:mb-12 pb-8" style={{backgroundColor: '#ffffff'}}>
        <div className="mt-4">
          <div className="hidden sm:block">
            <span className="ml-4 mt-4 text-2xl font-bold gradation-text">プロンプト選択</span>
          </div>
          
          {/* Mobile prompt sections */}
          <div className="sm:hidden mx-4 mt-4 p-4 rounded-lg border border-gray-200">
            <div className="text-sm mb-1 flex items-center justify-between">
              <span className="flex items-center font-bold">
                <span>設定中のプロンプト</span>
                <Tooltip label="選択中のアイテムをタップするとプロンプトを強調できます。">
                  <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-1"></img>
                </Tooltip>
              </span>
              <div className="flex items-center gap-2">
                { isPromptTranslating === false &&
                <span onClick={() => translatePrompt(true)} className="clickable flex text-xs text-gray-500 border border-gray-500 rounded px-2 py-[2px]">
                  JP<img src="/images/icon/icons8-right-arrow-32.png" className="w-[16px] h-[16px] mx-[3px]"></img>EN</span>
                }
                { isPromptTranslating === true &&
                <span className="clickable flex w-[70px] text-xs text-gray-500 border border-gray-500 rounded px-2 py-[2px]">
                  <Loader type="dots" className="mx-auto w-[32px] h-[16px]" size="16px" />
                </span>
                }
                <span className="text-sm clickable" onClick={() => clearPromptHint()}>クリア</span>
              </div>
            </div>
            <div className="flex flex-wrap gap-1">
              { selectedHint.filter((e) => e.isNegativePrompt === false).map((item) => (
                buildSelectedSpan(item, false)
              ))}
            </div>
            <div className="text-left mt-1 text-primary relative">
              <textarea className="w-full border py-1 px-2 resize-none text-sm h-[64px]"
               value={additionalPrompt} onChange={(e) => setAdditionalPrompt(e.target.value)} 
                placeholder="プロンプトを手動で入力。英語が推奨です。"></textarea>
            </div>

            {/* Toggle button for negative prompt details */}
            <div className="text-right mt-2">
              <button 
                onClick={() => setMobileNegativeVisible(!mobileNegativeVisible)}
                className="text-sm text-black clickable flex items-center ml-auto"
              >
                詳細
                <img 
                  src={mobileNegativeVisible ? "/images/icon/arrow-up.svg" : "/images/icon/arrow-down.svg"} 
                  className={mobileNegativeVisible ? "w-[12px] h-[12px] ml-1" : "w-[16px] h-[16px] ml-1"}
                  alt="toggle"
                />
              </button>
            </div>

            {/* Negative prompt section - conditionally shown */}
            {mobileNegativeVisible && (
              <>
                <div className="text-sm mb-2 mt-4 flex items-center justify-between">
                  <span className="font-bold">設定中のネガティブプロンプト</span>
                  <div className="flex items-center gap-2">
                    { isNegativePromptTranslating === false &&
                    <span onClick={() => translatePrompt(false)} className="clickable flex text-xs text-gray-500 border border-gray-500 rounded px-2 py-[2px]">
                      JP<img src="/images/icon/icons8-right-arrow-32.png" className="w-[16px] h-[16px] mx-[3px]"></img>EN</span>
                    }
                    { isNegativePromptTranslating === true &&
                    <span className="clickable flex w-[70px] text-xs text-gray-500 border border-gray-500 rounded px-2 py-[2px]">
                      <Loader type="dots" className="mx-auto w-[32px] h-[16px]" size="16px" />
                    </span>
                    }
                    <span className="text-sm clickable" onClick={() => clearNegativePromptHint()}>クリア</span>
                  </div>
                </div>
                <div className="flex flex-wrap gap-1">
                  { selectedHint.filter((e) => e.isNegativePrompt === true).map((item) => (
                    buildSelectedSpan(item, true)
                  ))}
                </div>
                <div className="text-left mt-2 text-primary relative">
                  <textarea placeholder="プロンプトを手動で入力。英語が推奨です。" className="w-full border py-1 px-2 resize-none text-sm h-[64px]" value={additionalNegativePrompt} onChange={(e) => setAdditionalNegativePrompt(e.target.value)} ></textarea>
                </div>
              </>
            )}
          </div>
          
          <div className="ml-4 mt-2 text-lg font-bold flex items-center">
            <span className="text-[16px]">モデルのテイストを選ぶ</span>
            <Tooltip label="作成したい画像の作風や表現のテイストを選びましょう。">
              <img src="/images/icon/icon-help.svg" className="w-[18px] h-[18px] clickable ml-2"></img>
            </Tooltip>
          </div>
          <div className="overflow-x-auto ml-4 mr-4 sm:max-w-[calc(100vw-530px)] max-w-[100vw]">
            <div className="flex ml-4" style={{ overflowX: "auto" }}>
            { mainTasteList.map((e) => (
              buildTasteImage(e)
            ))}
            </div>
          </div>
        </div>

        <div className="mx-4 mt-4">
          <div className="mb-2">

            <span className="text-lg font-bold flex items-center">
              <span className="text-[16px] font-bold">参照画像から生成する</span>
              <Tooltip multiline className="max-w-[300px]" label="アップロードした画像から生成ができます。生成画像設定エリアの「ノイズ除去の強度」からチューニングができます。SPからのアップロードは横画像のみ推奨です。著作権侵害の可能性のある画像はお控えください。">
                <img src="/images/icon/icon-help.svg" className="w-[18px] h-[18px] clickable ml-2"></img>
              </Tooltip>
              <a className="ml-2 text-sm text-gray-500 clickable underline" href="https://drop4i.com/article/help/img2img/">ヘルプ</a>
            </span>

          </div>
          <ImageUploader onBase64Change={(base64) => onSetBase64(base64)} />
        </div>

        <div id="inspiration-section">
          <div className="flex justify-between ml-4 mt-4 mr-4">
            <span className="text-lg font-bold flex items-center">
              <span className="text-[16px] font-bold">インスピレーションを得る</span>
              <Tooltip label="膨大な画像コレクションから構図やプロンプトのアイデアを得ましょう。">
                <img src="/images/icon/icon-help.svg" className="w-[18px] h-[18px] clickable ml-2"></img>
              </Tooltip>
            </span>

            <a href="/inspiration" className="flex items-center text-xs text-gray-500 clickable">もっと見る <img src="/images/icon/icon-right.svg" className="w-[16px] h-[16px]"></img></a>
          </div>
          <div className="overflow-x-auto ml-4 mr-4 sm:max-w-[calc(100vw-530px)] max-w-[100vw]">
            <div className="flex items-center" style={{ width: "max-content"}}>
              { inspirationList.map((e) => (
                <div key={`inspiration-${e.uid}`} className="mx-2 my-2" onClick={(elem) => onSelectInspiration(e)}>
                  <img loading="lazy" className="clickable h-[200px]" style={{ borderRadius: "8px"}} src={`${process.env.REACT_APP_IMAGE_URL}/sample/${e.imageFileName}`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-0 sm:border mx-1 sm:mx-4 pt-2 pb-2 mt-4 rounded-xl">
          <div className="flex justify-between items-center border-b border-gray-200">
            <div className="flex">
              <button
                className={`px-1 sm:px-6 py-2 sm:py-3 font-bold text-xs sm:text-lg transition-colors ${
                  !openedNegative ? 'text-[#0909FF] border-b-2 border-[#0909FF]' : 'text-gray-500'
                }`}
                onClick={() => { if(openedNegative) toggleNegative(); }}
              >
                <span className="flex items-center flex-wrap sm:flex-nowrap">
                  <img src="/images/icon/circle-plus-blue.svg" className="w-[14px] h-[14px] sm:w-[20px] sm:h-[20px] mr-1 sm:mr-2 flex-shrink-0" />
                  <span className="leading-tight">プロンプトを選ぶ</span>
                </span>
              </button>
              <button
                className={`px-1 sm:px-6 py-2 sm:py-3 font-bold text-xs sm:text-lg transition-colors ${
                  openedNegative ? 'text-[#F416BF] border-b-2 border-[#F416BF]' : 'text-gray-500'
                }`}
                onClick={() => { toggleNegative(); }}
              >
                <span className="flex items-center flex-wrap sm:flex-nowrap">
                  <img src="/images/icon/circle-plus-red.svg" className="w-[14px] h-[14px] sm:w-[20px] sm:h-[20px] mr-1 sm:mr-2 flex-shrink-0" />
                  <span className="leading-tight">ネガティブプロンプトを選ぶ</span>
                </span>
              </button>
            </div>
          </div>

          <div id="prompt-section" className={`${openedNegative ? 'hidden' : ''}`}>
            <div className="p-4">
              <div className="w-full box-border">
                <div className="relative">
                  <input value={searchText} type="text" onChange={(e) => onChangeSearchText(e.target.value)} className="border rounded box-border w-full pl-8 py-1" placeholder="任意のキーワードを入力 > 表示候補を選択"></input>
                  <img src="/images/icon/icon-search.svg" className="w-[20px] h-[20px] absolute left-2 top-2" />
                </div>
                { promptSearchResult.length >= 1 &&
                <div className="rounded border pl-2 mt-1 min-w-[240px] absolute bg-white z-10">
                  { promptSearchResult!.map((e) => (
                    <>
                    <div>{buildSearchOption(e)}</div>
                    </>
                  ))}
                </div>
                }
              </div>

              <div className="mt-4">
                { largeCategories && largeCategories!.map((largeCategory) => (
                  <>
                    <div className="text-lg mt-6">
                      <span className="font-bold">{largeCategory}</span>
                      <span onClick={(e) => setSelectedLargeCategory(largeCategory)} className="ml-4 text-sm text-gray text-[#868E96] clickable">{"> もっと見る"}</span>
                    </div>
                    <div className="max-w-full sm:max-w-[calc(100vw-550px)]">
                      { hintList.filter((e) => e.largeCategory === largeCategory && e.isPickup === true).map((item) => (
                        buildHintSpan(item, false)
                      ))}
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>

      <div id="negative-prompt-section" className={`${!openedNegative ? 'hidden' : ''}`}>
            <div className="p-4">
              
              
              <div className="w-full box-border">
                <div className="relative">
                  <input value={negativeSearchText} type="text" onChange={(e) => onChangeNegativeSearchText(e.target.value)} className="border rounded box-border w-full pl-8 py-1" placeholder="任意のキーワードを入力 > 表示候補を選択"></input>
                  <img src="/images/icon/icon-search.svg" className="w-[20px] h-[20px] absolute left-2 top-2" />
                </div>
                { negativePromptSearchResult.length >= 1 &&
                <div className="rounded border pl-2 mt-1 min-w-[240px] absolute bg-white z-10">
                  { negativePromptSearchResult!.map((e) => (
                    <>
                    <div>{buildSearchOption(e)}</div>
                    </>
                  ))}
                </div>
                }
              </div>

              <div className="mt-4">
                { negativelargeCategories && negativelargeCategories!.map((largeCategory) => (
                  <>
                    <div className="text-lg mt-6">
                      <span className="font-bold">{largeCategory}</span>
                      <span onClick={(e) => setSelectedLargeCategory(largeCategory)} className="ml-4 text-sm text-gray text-[#868E96] clickable">{"> もっと見る"}</span>
                    </div>
                    <div className="max-w-full sm:max-w-[calc(100vw-550px)]">
                      { negativeHintList.filter((e) => e.largeCategory === largeCategory && e.isPickup === true).map((item) => (
                        buildHintSpan(item, true)
                      ))}
                    </div>
                  </>
                ))}
              </div>
            </div>
          </div>
      </div>
              {/* Mobile SkyFlag Banner */
              }
      <div className="sm:hidden">
        <a href={`${getSkyFlagUrl()}`} target="_blank" onClick={() => {
          const url = getSkyFlagUrl();
          console.log('[AppBanner] Click (mobile):', url);
        }}>
          <img src="/images/skyflag-banner.jpg" className="w-full border-0" style={{border: 'none', outline: 'none'}}></img>
        </a>
      </div>


      </div>


      <div>
      <div id="right-cell-top" className="hidden sm:block w-[420px] min-w-[420px] ml-2 mr-4">
        <div className="w-[420px] min-w-[420px] ml-2 pl-4 pr-4 pt-2 mr-4 pb-2" style={{backgroundColor: '#03034F', color: "#fff", borderRadius: "8px"}}>
          <div className="flex justify-between mt-4">
            <span className="font-bold text-lg">画像生成</span>
            <span onClick={clearSettings} className="text-sm clickable">すべての設定をクリア</span>
          </div>
          <div className="text-sm mt-1 mb-1 flex items-center justify-between">
            <span className="flex items-center">
              <span>設定中のプロンプト</span>
              <Tooltip label="選択中のアイテムをタップするとプロンプトを強調できます。">
                <img src="/images/icon/icon-help-white.svg" className="w-[16px] h-[16px] clickable ml-1"></img>
              </Tooltip>
            </span>
            <div className="flex items-center gap-2">
              { isPromptTranslating === false &&
              <span onClick={() => translatePrompt(true)} className="clickable flex text-xs text-white border border-white rounded px-2 py-[2px]">
                JP<img src="/images/icon/icons8-right-arrow-32-white.png" className="w-[16px] h-[16px] mx-[3px]"></img>EN</span>
              }
              { isPromptTranslating === true &&
              <span className="clickable flex w-[70px] text-xs text-white border border-white rounded px-2 py-[2px]">
                <Loader type="dots" className="mx-auto w-[32px] h-[16px]" size="16px" />
              </span>
              }
              <span className="text-sm clickable" onClick={() => clearPromptHint()}>クリア</span>
            </div>
          </div>
          <div>
            { selectedHint.filter((e) => e.isNegativePrompt === false).map((item) => (
              buildSelectedSpan(item, false)
            ))}
          </div>
          <div className="text-left mt-1 text-primary relative">
            <textarea className="w-full border py-1 px-2 resize-none text-sm h-[64px]"
             value={additionalPrompt} onChange={(e) => setAdditionalPrompt(e.target.value)} 
              placeholder="プロンプトを手動で入力。英語が推奨です。"></textarea>
          </div>

          <div className="text-sm mb-1 mt-2 flex items-center justify-between">
            <span>設定中のネガティブプロンプト</span>
            <div className="flex items-center gap-2">
              { isNegativePromptTranslating === false &&
              <span onClick={() => translatePrompt(false)} className="clickable flex text-xs text-white border border-white rounded px-2 py-[2px]">
                JP<img src="/images/icon/icons8-right-arrow-32-white.png" className="w-[16px] h-[16px] mx-[3px]"></img>EN</span>
              }
              { isNegativePromptTranslating === true &&
              <span className="clickable flex w-[70px] text-xs text-white border border-white rounded px-2 py-[2px]">
                <Loader type="dots" className="mx-auto w-[32px] h-[16px]" size="16px" />
              </span>
              }
              <span className="text-sm clickable" onClick={() => clearNegativePromptHint()}>クリア</span>
            </div>
          </div>
          { selectedHint.filter((e) => e.isNegativePrompt === true).map((item) => (
            buildSelectedSpan(item, true)
          ))}
          <div className="text-left mt-2 text-primary relative">
            <textarea placeholder="プロンプトを手動で入力。英語が推奨です。" className="w-full border py-1 px-2 resize-none text-sm h-[64px]" value={additionalNegativePrompt} onChange={(e) => setAdditionalNegativePrompt(e.target.value)} ></textarea>
          </div>
          <div className="text-center mt-4">
            <Button size="lg" fullWidth disabled={processing} className="text-primary gradation-button hover-button rounded bg-white w-full" style={{ border: "1px solid gray" }} onClick={buildImage}>
              <img className="h-[20px] mr-1" src="/images/flare.png"></img>
              <span className="font-bold">画像生成する</span>
            </Button>
            <div className="text-xs mt-4 mb-2">
              <span>イメージが湧かない時は、</span>
              <a href="/inspiration" className="border-b">画像集からインスピレーションを得ましょう</a>
            </div>
          </div>
        </div>
      </div>
      
      <div id="generation-settings" className="hidden sm:block mt-4 sm:mt-0 pl-4 sm:mr-4 bg-[#fff] sm:bg-[unset]">
        <div className="w-full sm:w-[420px] sm:min-w-[420px] ml-0 pb-2 sm:ml-0 sm:pl-4 pr-4 sm:mr-4 sm:mt-4 pt-4 sm:rounded-md" style={{backgroundColor: '#fff'}}>
            <div className="font-bold">生成画像設定</div>
            <div>
              <label className="text-sm">画像の比率</label>
              <div className="flex justify-between">
              <Radio.Group value={aspectRatio} onChange={(e) => setAspectRatio(e)}>
                <Group>
              { ratioList.map((e) => (
                buildAspectRatioOption(e)
                // <span onClick={() => setAspectRatio(e.ratio!)} style={{ border: "1px solid gray", color: aspectRatio === e.ratio ? 'blue' : '', borderColor: aspectRatio === e.ratio ? 'blue' : '', }} className={`clickable rounded text-sm px-2 mr-2`}>{e.ratio}</span>
                ))}
                </Group>
              </Radio.Group>
              </div>
              <div></div>
            </div>

            { openedDetail === false &&
              <div className="pb-2">
                <div className="bg-gray-200 h-[1px] w-full mt-4 relative">
                  <span onClick={onClickToggleDetail} className="text-sm mt-[-12px] absolute  right-0 text-center top-[2px] px-4 bg-white w-fit left-[50%] text-gray-500 clickable flex items-center" style={{ transform: " translateX(-50%)"}}>
                    詳細設定
                    <img src="/images/icon/arrow-down.svg" className="w-[16px] h-[16px]"></img>
                  </span>
                </div>
              </div>
            }

            <Collapse in={openedDetail}>
              <>
              <div className="mt-4">
                <label className="text-sm">画像のフォーマット</label>
                <div className="">
                <Radio.Group value={fileFomat} onChange={(e) => setFileFomat(e)}>
                  <Group>
                    { fileFormatList.map((e) => (
                      <Radio color="#0909FF" key={`format-${e}`} label={e} value={e}></Radio>
                    ))}
                  </Group>
                </Radio.Group>
                </div>
                <div></div>
              </div>

              <div className="relative">
                <div className="mt-4">
                  <label className="text-sm">生成画像数</label>
                  <div className="">
                  <Radio.Group value={bulkCount.toString()} onChange={(e) => setBulkCount(parseInt(e))}>
                    <Group>
                      { bulkCountOption.map((e) => (
                        <Radio color="#0909FF" key={`bulk-${e}`} label={e.toString()} value={e.toString()}></Radio>
                      ))}
                    </Group>
                  </Radio.Group>
                  </div>
                  <div></div>
                </div>

                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-sm">シード値</label>
                    <Tooltip label="画像生成した際にランダム生成される値です。同じシード値とプロンプトを使うと同じ画像を再現できます。">
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                    <NumberInput hideControls placeholder="シード値を手動入力" value={seed} onChange={(e) => setSeed(e.toString())}></NumberInput>
                  </div>
                  <div></div>
                </div>

                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-sm">ステップ数 (10 ~ 40)</label>
                    <Tooltip label="生成画像ノイズを除去する回数です。ステップ数が多いほど高品質な画像が生成される一方で処理時間が長くなります。デフォルト値20が推奨です。">
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                  <Slider color="#0909FF" min={10} max={40} defaultValue={stepCount} onChange={(e) => setStepCount(e)} marks={[{ value: 10 }, { value: 20 }, { value: 30 }, { value: 40 }]} />
                  </div>
                  <div></div>
                </div>

                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-sm">スケール (3 ~ 10)</label>
                    <Tooltip label="プロンプトに対する生成画像の忠実度を調整できます。スケールを大きくするほど忠実度が向上します。7前後が推奨です。">
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                    <Slider color="#0909FF" min={3} max={10} step={0.1} defaultValue={scale} onChange={(e) => setScale(e)} marks={[{ value: 3 }, { value: 5.5 }, { value: 8 }, { value: 10 }]} />
                  </div>
                  <div></div>
                </div>

                <div className="mt-4 mb-4">
                  <div className="flex items-center">
                    <label className="text-sm">img2img ノイズ除去の強度(0.1 ~ 1.0)</label>
                    <Tooltip multiline className="max-w-[300px]" label={`ノイズ除去の強度（Denoising strength）設定で画像の忠実度を調整できます。０に近いほど元画像に忠実な画像が生成され、１に近いほどプロンプトにならったオリジナル性の高い画像が生成されます。推奨は0.7-0.8です。`}>
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                    <Slider color="#0909FF" min={0.1} max={1} step={0.01} defaultValue={strength} onChange={(e) => setStrength(e)} marks={[{ value: 0.25 }, { value: 0.5 }, { value: 0.75 }]} />
                  </div>
                  <div></div>
                </div>

                <div className="mt-4">
                  <div className="flex items-center">
                    <label className="text-sm">img2img 画像リサイズ</label>
                    <Tooltip multiline className="max-w-[300px]" label={`img2imgのアップロード画像と生成画像の指定サイズが異なる場合の補正方法を選択できます。[推奨]Resize and fillは縦横比維持で不足部分を補完します。Just resizeは縦横比無視で引き伸ばします。Just resize latent upscalerでは、縦横比無視の引き伸ばしかつ高解像度化します。Crop and resizeは縦横比維持で一部を切り取り補正します。`}>
                      <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                    </Tooltip>
                  </div>
                  <div className="">
                  <Radio.Group variant="vertical" value={resizeMode} onChange={(e) => setResizeMode(e)}>
                    { resizeModeList.map((e) => (
                      <Radio color="#0909FF" key={`format-${e}`} className="mb-1" label={e.label} value={e.value}></Radio>
                    ))}
                  </Radio.Group>
                  </div>
                  <div></div>
                </div>

                { subscription?.internalProductId === 'free' &&
                <div className="absolute top-[0px] bg-[#ffffffdd] z-[10] w-full">
                  <div className="text-center h-[320px] mt-[90px]">
                    <span className="text-sm text-[#F416BF] font-bold mt-[120px]">2以上の同時画像生成、シード値入力、ステップ数、スケール<br/>
                    これらの機能はLiteプラン以上でお使いいただけます。</span>
                  </div>
                </div>
                }
              </div>
              </>
              </Collapse>

              { openedDetail === true &&
              <div className="pb-2 pt-1">
                <div className="bg-gray-200 h-[1px] w-full mt-4 relative">
                  <span onClick={onClickToggleDetail} className="text-sm mt-[-12px] absolute  right-0 text-center top-[2px] px-4 bg-white w-fit left-[50%] text-gray-500 clickable flex items-center" style={{ transform: " translateX(-50%)"}}>
                    閉じる
                    <img src="/images/icon/arrow-up.svg" className="w-[12px] h-[12px] ml-1"></img>
                  </span>
                </div>
              </div>
              }
          </div>
        </div>

        {/* Mobile Settings Modal */}
        {mobileSettingsVisible && (
          <div className="sm:hidden fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end">
            <div className="w-full bg-white rounded-t-lg max-h-[80vh] transition-transform duration-300 ease-out transform translate-y-0 flex flex-col">
              <div className="bg-white border-b p-4 flex justify-between items-center rounded-t-lg">
                <h3 className="text-lg font-bold">生成画像設定</h3>
                <button 
                  onClick={() => updateMobileSettingsVisible(false)}
                  className="p-2 clickable"
                >
                  <img src="/images/icon-close.svg" className="w-[24px] h-[24px]" alt="閉じる" />
                </button>
              </div>
              <div className="p-4 pb-32 overflow-y-auto flex-1">
                <div>
                  <label className="text-sm">画像の比率</label>
                  <div className="grid grid-cols-3 gap-2 mt-1">
                  <Radio.Group value={aspectRatio} onChange={(e) => setAspectRatio(e)}>
                    <Group className="contents">
                  { ratioList.map((e) => (
                    buildAspectRatioOption(e)
                    ))}
                    </Group>
                  </Radio.Group>
                  </div>
                  <div></div>
                </div>

                { openedDetail === false &&
                  <div className="pb-2">
                    <div className="bg-gray-200 h-[1px] w-full mt-4 relative">
                      <span onClick={onClickToggleDetail} className="text-sm mt-[-12px] absolute  right-0 text-center top-[2px] px-4 bg-white w-fit left-[50%] text-gray-500 clickable flex items-center" style={{ transform: " translateX(-50%)"}}>
                        詳細設定
                        <img src="/images/icon/arrow-down.svg" className="w-[16px] h-[16px]"></img>
                      </span>
                    </div>
                  </div>
                }

                <Collapse in={openedDetail}>
                  <>
                  <div className="mt-4">
                    <label className="text-sm">画像のフォーマット</label>
                    <div className="">
                    <Radio.Group value={fileFomat} onChange={(e) => setFileFomat(e)}>
                      <Group>
                        { fileFormatList.map((e) => (
                          <Radio color="#0909FF" key={`format-${e}`} label={e} value={e}></Radio>
                        ))}
                      </Group>
                    </Radio.Group>
                    </div>
                    <div></div>
                  </div>

                  <div className="relative">
                    <div className="mt-4">
                      <label className="text-sm">生成画像数</label>
                      <div className="">
                      <Radio.Group value={bulkCount.toString()} onChange={(e) => setBulkCount(parseInt(e))}>
                        <Group>
                          { bulkCountOption.map((e) => (
                            <Radio color="#0909FF" key={`bulk-${e}`} label={e.toString()} value={e.toString()}></Radio>
                          ))}
                        </Group>
                      </Radio.Group>
                      </div>
                      <div></div>
                    </div>
                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-sm">シード値</label>
                        <Tooltip label="画像生成した際にランダム生成される値です。同じシード値とプロンプトを使うと同じ画像を再現できます。">
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                        <NumberInput hideControls placeholder="シード値を手動入力" value={seed} onChange={(e) => setSeed(e.toString())}></NumberInput>
                      </div>
                      <div></div>
                    </div>

                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-sm">ステップ数 (10 ~ 40)</label>
                        <Tooltip label="生成画像ノイズを除去する回数です。ステップ数が多いほど高品質な画像が生成される一方で処理時間が長くなります。デフォルト値20が推奨です。">
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                      <Slider color="#0909FF" min={10} max={40} defaultValue={stepCount} onChange={(e) => setStepCount(e)} marks={[{ value: 10 }, { value: 20 }, { value: 30 }, { value: 40 }]} />
                      </div>
                      <div></div>
                    </div>

                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-sm">スケール (3 ~ 10)</label>
                        <Tooltip label="プロンプトに対する生成画像の忠実度を調整できます。スケールを大きくするほど忠実度が向上します。7前後が推奨です。">
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                        <Slider color="#0909FF" min={3} max={10} step={0.1} defaultValue={scale} onChange={(e) => setScale(e)} marks={[{ value: 3 }, { value: 5.5 }, { value: 8 }, { value: 10 }]} />
                      </div>
                      <div></div>
                    </div>

                    <div className="mt-4 mb-4">
                      <div className="flex items-center">
                        <label className="text-sm">img2img ノイズ除去の強度(0.1 ~ 1.0)</label>
                        <Tooltip multiline className="max-w-[300px]" label={`ノイズ除去の強度（Denoising strength）設定で画像の忠実度を調整できます。０に近いほど元画像に忠実な画像が生成され、１に近いほどプロンプトにならったオリジナル性の高い画像が生成されます。推奨は0.7-0.8です。`}>
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                        <Slider color="#0909FF" min={0.1} max={1} step={0.01} defaultValue={strength} onChange={(e) => setStrength(e)} marks={[{ value: 0.25 }, { value: 0.5 }, { value: 0.75 }]} />
                      </div>
                      <div></div>
                    </div>

                    <div className="mt-4">
                      <div className="flex items-center">
                        <label className="text-sm">img2img 画像リサイズ</label>
                        <Tooltip multiline className="max-w-[300px]" label={`img2imgのアップロード画像と生成画像の指定サイズが異なる場合の補正方法を選択できます。[推奨]Resize and fillは縦横比維持で不足部分を補完します。Just resizeは縦横比無視で引き伸ばします。Just resize latent upscalerでは、縦横比無視の引き伸ばしかつ高解像度化します。Crop and resizeは縦横比維持で一部を切り取り補正します。`}>
                          <img src="/images/icon/icon-help.svg" className="w-[16px] h-[16px] clickable ml-2"></img>
                        </Tooltip>
                      </div>
                      <div className="">
                      <Radio.Group variant="vertical" value={resizeMode} onChange={(e) => setResizeMode(e)}>
                        { resizeModeList.map((e) => (
                          <Radio color="#0909FF" key={`format-${e}`} className="mb-1" label={e.label} value={e.value}></Radio>
                        ))}
                      </Radio.Group>
                      </div>
                      <div></div>
                    </div>

                    { subscription?.internalProductId === 'free' &&
                    <div className="absolute top-[0px] bg-[#ffffffdd] z-[10] w-full">
                      <div className="text-center h-[320px] mt-[90px]">
                        <span className="text-sm text-[#F416BF] font-bold mt-[120px]">2以上の同時画像生成、シード値入力、ステップ数、スケール<br/>
                        これらの機能はLiteプラン以上でお使いいただけます。</span>
                      </div>
                    </div>
                    }
                  </div>
                  </>
                  </Collapse>

                  { openedDetail === true &&
                  <div className="pb-2 pt-1">
                    <div className="bg-gray-200 h-[1px] w-full mt-4 relative">
                      <span onClick={onClickToggleDetail} className="text-sm mt-[-12px] absolute  right-0 text-center top-[2px] px-4 bg-white w-fit left-[50%] text-gray-500 clickable flex items-center" style={{ transform: " translateX(-50%)"}}>
                        閉じる
                        <img src="/images/icon/arrow-up.svg" className="w-[12px] h-[12px] ml-1"></img>
                      </span>
                    </div>
                  </div>
                  }
              </div>
            </div>
          </div>
        )}

        <div id="generation-history" className="hidden sm:block pl-2 sm:pl-0 pr-2 sm:pr-0 sm:ml-6 mt-4 sm:max-w-[400px] w-full box-border mb-[320px] sm:mb-6">
        { isLoggedIn === true &&
            <>
            <div className="font-bold text-lg flex justify-between">
              <span>生成履歴</span>
              <a href="/generation-history" className="flex items-center text-sm text-gray-500">もっと見る<img src="/images/icon/icon-right.svg" className="w-[16px] h-[16px]"></img></a>
            </div>
            <div className="flex flex-wrap -mx-0.5">
            { requestList.map((e) => {
              if (e.status === 'started') {
                return (
                  <div key={`history-${e.requestId}`} className="w-1/2 sm:w-1/4 px-0.5 mb-1">
                    <div className="flex w-full aspect-square border">
                      <div className="m-auto text-center w-full">
                        <Loader type="dots" className="mx-auto" size="20px" />
                        <span className="text-xs">生成中</span>
                      </div>
                    </div>
                  </div>
                );
              }
              
              if (e.status === 'complete') {
                return (
                  <div key={`history-${e.requestId}`} className="w-1/2 sm:w-1/4 px-0.5 mb-1">
                    { e.isNsfw === 1 ? (
                      <div onClick={() => onClickGeneratedImage(e)} className="w-full aspect-square rounded-lg bg-black text-white text-center flex items-center justify-center text-xs p-1 clickable">不適切な画像</div>
                    ) : (
                      <img onClick={() => onClickGeneratedImage(e)} className="clickable w-full aspect-square object-cover rounded-lg" src={`${process.env.REACT_APP_IMAGE_URL}/${e.requestId}_mid`} />
                    )}
                  </div>
                );
              }
              
              if (e.status === 'error') {
                return (
                  <div key={`history-${e.requestId}`} className="w-1/2 sm:w-1/4 px-0.5 mb-1">
                    <div onClick={() => onClickGeneratedImage(e)} className="w-full aspect-square rounded-lg bg-black text-white text-center flex items-center justify-center text-xs p-1 clickable">エラーが発生しました</div>
                  </div>
                );
              }
              
              return null;
            })}
            </div>
            <div className="mt-6">
              <a href={`${getSkyFlagUrl()}`} target="_blank" onClick={() => {
                const url = getSkyFlagUrl();
                console.log('[AppBanner] Click (right-col):', url);
              }}>
                <img src="/images/skyflag-banner.jpg" className="w-full"></img>
              </a>
            </div>
            </>
          }
        </div>
      </div>


      <div id="mobile-bottom-cell" className="sm:hidden fixed bottom-0 left-0 right-0 w-full bg-[#03034F] py-2 z-50" >
        <div className="flex items-center px-2">
          {/* Left side icons */}
          <div className="flex items-center">
            {/* Inspiration icon */}
            <button 
              onClick={() => navigate('/inspiration')}
              className="flex flex-col items-center justify-center px-2 py-1"
            >
              <img src="/images/icon/icons8-gallery-512-white.png" className="w-6 h-6" alt="インスピレーション" />
              <span className="text-[9px] text-white mt-1">インスピ</span>
            </button>
            
            {/* Generated images icon */}
            <button 
              onClick={() => navigate('/generation-history')}
              className="flex flex-col items-center justify-center px-2 py-1"
            >
              <img src="/images/icon/icons8-gallery-480-white.png" className="w-6 h-6" alt="生成画像" />
              <span className="text-[9px] text-white mt-1">生成履歴</span>
            </button>
            
            {/* Settings icon */}
            <button 
              onClick={() => updateMobileSettingsVisible(true)}
              className="flex flex-col items-center justify-center px-2 py-1"
            >
              <img src="/images/icon/icons8-config-500-white.png" className="w-6 h-6" alt="画像設定" />
              <span className="text-[9px] text-white mt-1">画像設定</span>
            </button>
          </div>
          
          {/* Right side generation button */}
          <div className="flex-1 ml-2">
            <button
              onClick={buildImage}
              disabled={processing}
              className="w-full gradation-button text-white font-bold py-2.5 rounded-lg disabled:opacity-50 text-sm"
            >
              画像生成する
            </button>
          </div>
        </div>
      </div>
    </div>
  </>;
}
